import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Zap, Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/tests", label: "Tests" },
  { to: "/games", label: "Games" },
  { to: "/brain", label: "Brain" },
  { to: "/gaming", label: "Gamers" },
  { to: "/leaderboard", label: "Leaderboard" },
  { to: "/daily", label: "Challenges" },
  { to: "/guides", label: "Guides" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-black/70 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 font-display font-black text-lg">
          <Zap className="text-[#39FF14] fill-[#39FF14]" size={22} />
          <span>Reaction<span className="text-[#39FF14]">Lab</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${loc.pathname === n.to ? "text-[#39FF14]" : "text-white/70 hover:text-white hover:bg-white/5"}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : `/profile/${user.username}`} data-testid="profile-link"
                className="flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white">
                {user.avatar
                  ? <img src={user.avatar} alt="" className="w-8 h-8 rounded-full object-cover" />
                  : <span className="w-8 h-8 rounded-full bg-[#39FF14]/20 text-[#39FF14] flex items-center justify-center font-bold">{user.username?.[0]?.toUpperCase()}</span>}
                {user.username}
              </Link>
              <button data-testid="logout-button" onClick={() => { logout(); navigate("/"); }}
                className="text-sm text-white/50 hover:text-white">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/auth" data-testid="signin-link" className="text-sm font-medium text-white/80 hover:text-white px-3">Sign In</Link>
              <Link to="/auth?mode=register" data-testid="create-account-link"
                className="text-sm font-bold bg-white text-black px-4 py-2 rounded-full hover:bg-white/90 transition">Create Account</Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2" data-testid="mobile-menu-button" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-black px-4 py-4 flex flex-col gap-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="px-4 py-3 rounded-xl text-white/80 hover:bg-white/5">{n.label}</Link>
          ))}
          <div className="h-px bg-white/5 my-2" />
          {user ? (
            <>
              <Link to={`/profile/${user.username}`} onClick={() => setOpen(false)} className="px-4 py-3 rounded-xl text-white/80">Profile</Link>
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="px-4 py-3 text-left rounded-xl text-white/60">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/auth" onClick={() => setOpen(false)} className="px-4 py-3 rounded-xl text-white/80">Sign In</Link>
              <Link to="/auth?mode=register" onClick={() => setOpen(false)} className="px-4 py-3 rounded-xl bg-[#39FF14] text-black font-bold text-center">Create Account</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
